import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid, FGridMoneyCell } from '../grid';
import { BudgetConsolidationAccountRow } from './budgetconsolidation.models';

type Props = { rows: BudgetConsolidationAccountRow[]; loading?: boolean };

export default class BudgetConsolidationAccountGrid extends React.PureComponent<Props> {
  private columns: GridColDef[] = [
    { field: 'accountcode', headerName: 'Account', width: 130, cellClassName: 'master-cell' },
    { field: 'accountname', headerName: 'Account Name', flex: 1, minWidth: 280, cellClassName: 'master-cell' },
    { field: 'activitybudget', headerName: 'Activity', width: 150, renderCell: FGridMoneyCell, cellClassName: 'source-cell' },
    { field: 'directbudget', headerName: 'Direct', width: 150, renderCell: FGridMoneyCell, cellClassName: 'source-cell' },
    { field: 'investmentbudget', headerName: 'Investment', width: 150, renderCell: FGridMoneyCell, cellClassName: 'source-cell' },
    { field: 'totalbudget', headerName: 'Consolidated', width: 160, renderCell: FGridMoneyCell, cellClassName: 'computed-cell' },
    { field: 'approvedamount', headerName: 'Arbitrated', width: 160, renderCell: FGridMoneyCell, cellClassName: 'governed-cell' },
    { field: 'variance', headerName: 'Variance', width: 150, renderCell: FGridMoneyCell, cellClassName: 'computed-cell' },
  ];

  render() {
    return (
      <FDataGrid
        title="Consolidation by Account"
        subtitle="Read-only account view of Activity, Direct and Investment budgets. Arbitration decisions are recorded separately."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={500}
        getRowId={(row: BudgetConsolidationAccountRow) => row.id}
        sx={{
          '& .master-cell': { bgcolor: 'info.lighter' },
          '& .source-cell': { bgcolor: 'action.hover' },
          '& .computed-cell': { bgcolor: 'success.lighter', fontWeight: 700 },
          '& .governed-cell': { bgcolor: 'warning.lighter', fontWeight: 700 },
        }}
      />
    );
  }
}
